var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCurrencyDollarSimple = function SvgIconCurrencyDollarSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.25a1 1 0 0 1 1 1V3.5h.5a4.75 4.75 0 0 1 4.75 4.75 1 1 0 1 1-2 0A2.75 2.75 0 0 0 13.5 5.5h-3.375a2.75 2.75 0 1 0 0 5.5h4.125a4.75 4.75 0 1 1 0 9.5H13v1.25a1 1 0 1 1-2 0V20.5H9.75A4.75 4.75 0 0 1 5 15.75a1 1 0 1 1 2 0 2.75 2.75 0 0 0 2.75 2.75h4.5a2.75 2.75 0 1 0 0-5.5h-4.125a4.75 4.75 0 1 1 0-9.5H11V2.25a1 1 0 0 1 1-1"
  })));
};
export default SvgIconCurrencyDollarSimple;